import { render } from "./Returns.vue?vue&type=template&id=0c9d46e4"
import script from "./Returns.vue?vue&type=script&lang=js"
export * from "./Returns.vue?vue&type=script&lang=js"
script.render = render

export default script